"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class OrderAPI {
    client;
    constructor(client) {
        this.client = client;
    }
    async getOrder(orderId) {
        return await this.client.get(`/orders/${orderId}`);
    }
    async getOrderItems(orderId) {
        return await this.client.get(`/orders/${orderId}/items`);
    }
    async listOrders({ customerId: _customerId, ...rest }) {
        return await this.client.get('/orders', rest);
    }
    async convertInhouseToThirdParty(orderId) {
        return await this.client.client.orders.order.convertInhouseToThirdPartyDelivery({
            params: { orderId },
        });
    }
    async convertPickupToDelivery(orderId, address) {
        return await this.client.client.orders.order.convertPickupToDelivery({
            params: { orderId },
            body: { address },
        });
    }
}
exports.default = OrderAPI;
//# sourceMappingURL=index.js.map